import React, { useEffect, useState } from "react";
import { Button, Descriptions, Tag } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import { formatDate } from "../../../utils/dateFormatter";

const ENTRY_TYPE_COLOR = {
  work: "blue",
  rest: "green",
  break: "orange",
  meal: "purple",
  overtime: "red",
};

const ViewRestHours = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [loader, set_loader] = useState(false);

  useEffect(() => {
    const staffData = JSON.parse(localStorage.getItem("staff_dashboard") || "{}");
    set_staff_dashboard(staffData);
    GET_REST_HOURS_API();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const GET_REST_HOURS_API = () => {
    set_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("log_id", atob(id));
    try {
      post(ApiURL.view_or_update_rest_hours_st, FORM_DATA).then((res) => {
        if (res?.status === true) setData(res.data || res.rest_hours || null);
        set_loader(false);
      });
    } catch (error) {
      console.error("Error fetching entry:", error);
      set_loader(false);
    }
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} buttonShow={false} />

      <div className="card p-3 mt-3" style={{ opacity: loader ? 0.5 : 1 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h5 className="mb-0">Rest Hours Entry</h5>
          <Button onClick={() => navigate("/log-hours")}>Back to List</Button>
        </div>

        <Descriptions bordered column={3} size="small">
          <Descriptions.Item label="Date">{formatDate(data?.date)}</Descriptions.Item>
          <Descriptions.Item label="Entry Type">
            <Tag
              color={ENTRY_TYPE_COLOR[data?.entry_type] || "default"}
              style={{ textTransform: "capitalize" }}
            >
              {data?.entry_type || "—"}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Duration">
            {data?.duration !== undefined ? `${data.duration} hrs` : "—"}
          </Descriptions.Item>
          <Descriptions.Item label="Start Time">{data?.start_time || "—"}</Descriptions.Item>
          <Descriptions.Item label="End Time">{data?.end_time || "—"}</Descriptions.Item>
          <Descriptions.Item label="Staff ID">{data?.staff_id || "—"}</Descriptions.Item>
          <Descriptions.Item label="Description" span={3}>
            {data?.description || "—"}
          </Descriptions.Item>
          <Descriptions.Item label="Created At">{data?.created_at || "—"}</Descriptions.Item>
          <Descriptions.Item label="Updated At">{data?.updated_at || "—"}</Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};

export default ViewRestHours;
